import { Role } from '@fullstory/proto/fs/services/orgs';
import { assertExhaustive } from '@fullstory/typeutils';
import { intl } from '@fullstory/intl';

export const ROLES: { [role: number]: string } = {
  [Role.UNKNOWN]: intl.formatMessage({ defaultMessage: 'Not member', id: 'MV0BAx' }),
  [Role.UMBRELLA_MANAGER]: intl.formatMessage({ defaultMessage: 'Umbrella manager', id: '5M/+De' }),
  [Role.ADMIN]: intl.formatMessage({ defaultMessage: 'Admin', id: 'iHN12u' }),
  [Role.ARCHITECT]: intl.formatMessage({ defaultMessage: 'Architect', id: 'Kyz5JP' }),
  [Role.USER]: intl.formatMessage({ defaultMessage: 'Standard', id: 'cb2kY6' }),
  [Role.VIEW_ONLY]: intl.formatMessage({ defaultMessage: 'Guest', id: 'zF7Cth' }),
  [Role.EXPLORER]: intl.formatMessage({ defaultMessage: 'Explorer', id: 'mJN/zn' }),
};

export const labelForRole = (role: Role) => ROLES[role] || 'User';

// Returns a string representation of the role for use in custom vars and analytics.
export const stringFromRole = (role: Role): string => {
  switch (role) {
    case Role.UNKNOWN:
      return '';
    case Role.UMBRELLA_MANAGER:
      return 'umbrella-manager';
    case Role.ADMIN:
      return 'owner';
    case Role.ARCHITECT:
      return 'architect';
    case Role.VIEW_ONLY:
      return 'viewer';
    case Role.USER:
      return 'agent';
    case Role.EXPLORER:
      return 'explorer';
    default:
      assertExhaustive(role);
  }
};
